/**
 * The scenix mark: a play triangle and a playhead.
 *
 * Both halves mean something. The triangle is the thing being made, and the bar
 * beside it is the playhead on the scrub bar, which is the one screen the whole
 * product is built around (ADR 000025). It is not a bare play glyph, which
 * every media application already owns.
 *
 * Drawn in currentColor and the accent variable rather than fixed colours, so
 * it inherits wherever it is placed and needs no second file for a light
 * ground.
 */
export function LogoMark({ size = 22 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      {/* Stroked as well as filled, with round joins, so the corners are eased
          rather than needle-sharp at the tip. */}
      <path
        d="M6.4 5.2 16.2 12 6.4 18.8Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <rect x="19" y="3.4" width="2.6" height="17.2" rx="1.3" fill="var(--accent)" />
    </svg>
  );
}

/** The mark and the name, for the header and anywhere else the brand appears. */
export function Logo() {
  return (
    <span className="logo">
      <LogoMark />
      <span className="logo-word">scenix</span>
    </span>
  );
}
